import { CompetenceView } from "@features/rh/competences/components/CompetenceView";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { Award } from "lucide-react";

function CompetenceViewWrapper() {
  const { id } = useParams({ from: "/_app/rh/competences/$id/view" });
  return <CompetenceView competenceId={Number(id)} />;
}

export const Route = createFileRoute("/_app/rh/competences/$id/view")({
  staticData: {
    title: "Détails compétence",
    icon: Award,
    permission: PERMISSIONS.RH.PERSONNE.VIEW,
    module: "rh",
    showInTab: false,
    showInNav: false,
    showInBreadcrumb: true,
  },
  component: CompetenceViewWrapper,
});
